export default __webpack_public_path__ + "static/media/jiaoyu.e6e39ff1.jpg";